export enum TelemetryEvent {
   COMPONENT_ACCESSED = 'ComponentAccessed',
   AUTHENTICATED_USER = 'AuthenticatedUser',
}

export enum AppComponent {
   DELETE_PROMPT = 'DeletePrompt',
}
